<template>
    <div class="toggle-block-grey"  :class="{'close': close }">
        <span @click="toggleClose" class="toggle-close" >
            <img :src="arrowImg" :style="{transform: 'rotate('+arrowRotate+'deg)'}" alt="">
        </span>
        <div class="toggle-title">
            <slot name="toggle-title"></slot>
        </div>
        <div class="toggle-body">
            <slot name="toggle-body"></slot>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            arrowImg: require('@/assets/img/icon/arrow_down_gray.svg'),
            arrowRotate: '0',
            close: this.isClose
        }
    },
    props:{
        isClose: {
            default: true,
            type: Boolean
        }
    },
    watch: {
        close: function () {
            if(this.close){
                this.arrowImg = require('@/assets/img/icon/arrow_down_gray.svg'),
                this.arrowRotate = '0'
            }else{
                this.arrowImg = require('@/assets/img/icon/arrow_down_gray.svg'),
                this.arrowRotate = '180'
            }
        },
        immediate: true
    },
    methods: {
        toggleClose: function () {
            this.close = !this.close
        },
    }
}
</script>
<style lang="scss"  >
    .toggle-block-grey{
        position: relative;
        width: 100%;

        border-radius: 4px;
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        border: solid 1px #e0dfde;
        background-color: #ffffff;
        margin-bottom: 20px;

        .toggle-close{
            position: absolute;
            right: 12px;
            top: 16px;
            cursor: pointer;
        }
        >.toggle-title{
            display: flex;
            align-items: center;
            font-size: 20px;
            
            padding: 15px 12px 17px 16px;
            >img{
                margin-right: 4px;
            }
        }
        >.toggle-body{
            padding: 2px 44px 10px 44px;
        }
    }
    .toggle-block-grey.close{
        .toggle-body{
            display: none;
        }
    }
    @media screen and (max-width: 1280px) {
        .toggle-block{
            width: 1140px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tools/toggleBlockGrey.vue